import {
  OvlAddComponent,
  OvlAddScreen,
} from "../../../../../../../_ovlclient/src/global/globals"
import { CompDownloadPopup } from "../../../parts/downloadpopup/downloadpopup"
import { CompFileList } from "../../../parts/filelist/filelist"
import { CompDashboard } from "./dashboard"

export const GENDashboard_Init = () => {
  OvlAddComponent("comp-filelist", CompFileList)
  OvlAddComponent("comp-downloadpopup", CompDownloadPopup)
  OvlAddScreen(CompDashboard, "GENDashboard")
}
